import { Link } from 'react-router-dom';
import { CustomLinkProps } from './customLink.types';

const CustomLink: (props: CustomLinkProps) => JSX.Element = ({
  label,
  className,
  to,
  type,
  icon,
  href,
  target,
  disabled,
  ariaLabel,
  tabIndex,
}) => {
  const fullClass = `customLink ${type}${className ? ' ' + className : ''}${
    disabled ? ' ' + 'disabled' : ''
  }`;
  const appliedIcon = icon && <em className={icon} aria-hidden="true" />;
  return !href ? (
    <Link
      className={fullClass}
      to={to ?? ''}
      aria-disabled={disabled}
      tabIndex={tabIndex}
    >
      {appliedIcon}
      <span className="link__label">{label}</span>
    </Link>
  ) : (
    <a
      className={fullClass}
      href={href}
      target={target}
      aria-disabled={disabled}
      aria-label={ariaLabel}
      tabIndex={tabIndex}
    >
      {appliedIcon}
      <span className="link__label">{label}</span>
    </a>
  );
};

export default CustomLink;
